// i18n area 'hci' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO (lingua SORGENTE, regola
// 2026-08-03). Glossario di sezione: endurjöfnun (ribilanciamento), bilunarsvið
// (dominio di guasto), samhýstur (colocato), stigveldi (gerarchia), dulkóðun
// (crittografia), eyðilegging (distruzione); il lessico Ceph resta invariato
// (MON, MGR, MDS, OSD, PG, CRUSH, crushmap, crushtool, scrub, backfill,
// recovery, BlueStore, dmcrypt, quorum, standby, sweep, osdmap, fsid, noout…),
// «deploy» si traslittera col participio deployað/deployaður come prestito vivo.
// Sidecar anti-stantie: ../meta/hci.is-IS.meta.json.
import type { enUS } from './hci'

export const isIS: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph-klasar',
      createButton: 'Búa til Ceph-klasa',
      emptyTitle: 'Enginn stýrður Ceph-klasi',
      emptyBody: 'TVirt dreifir og á Ceph á meðlimshnútunum, ofursamleitið með VM-álaginu. Búðu til klasa: fyrsti monitorinn og manager hans fæðast sjálfkrafa á valda stjórnhnútnum — stækkaðu hann svo með fleiri monitorum og OSD-tækjum.',
      pageTitle: 'Ceph-klasi',
      colState: 'Staða',
      colMembers: 'Meðlimir',
      colSize: 'Stærð',
      colVersion: 'Ceph-útgáfa',
      sizeCell: '{used} GiB notuð af {total} GiB alls',
      phase: {
        'not-deployed': 'Ekki deployað',
        deploying: 'Deploy í gangi',
        healthy: 'Heilbrigður',
        degraded: 'Skertur',
        error: 'Villa',
        destroying: 'Í eyðileggingu',
        destroyed: 'Eyðilagður'
      },
      health: {
        HEALTH_OK: 'Heilbrigður (HEALTH_OK)',
        HEALTH_WARN: 'Með aðvaranir (HEALTH_WARN)',
        HEALTH_ERR: 'Í villu (HEALTH_ERR)',
        unknown: 'Ekki enn athuguð',
        observedAt: 'athuguð {time}'
      },
      create: {
        title: 'Búa til Ceph-klasa',
        info: 'Þegar nýr Ceph-klasi er búinn til þarf að velja fyrsta hnútinn þar sem MON- og MGR-hlutverkin verða sett upp. Einnig þarf að tilgreina hvaða undirnet á að nota fyrir Ceph-umferðina: public-undirnetið er notað fyrir almenna netumferð, en cluster-undirnetið er notað fyrir innri speglanir milli OSD-anna; það þarf ekki endilega ólík undirnet.',
        controlNode: 'Stjórnhnútur',
        controlNodeHint: 'Meðlimshnúturinn þar sem fyrsti MON + MGR fæðast.',
        publicSubnet: 'Public-undirnet',
        publicSubnetHint: 'Undirnet skráð í IPAM — public_network Ceph. Óbreytanlegt eftir stofnun.',
        clusterSubnet: 'Cluster-undirnet',
        clusterSubnetHint: 'Undirnet skráð í IPAM — cluster_network Ceph (speglun/backfill).',
        noSubnets: 'Ekkert undirnet skráð — búðu þau fyrst til í IPAM',
        sameSubnet: 'Sama undirnet fyrir public- og cluster-umferð',
        sameSubnetHint: 'Hakað = cluster-netið (speglun/backfill) fellur saman við public. Óhakað = veldu undirnet þess OG vistfang stjórnhnútsins innan þess.',
        controlAddress: 'Vistfang stjórnhnútsins',
        controlAddressHint: 'Vistfang sem IPAM þekkir fyrir hnútinn innan public-undirnetsins.',
        controlClusterAddress: 'Cluster-vistfang stjórnhnútsins',
        controlClusterAddressHint: 'Vistfang sem IPAM þekkir fyrir hnútinn innan cluster-undirnetsins.',
        noAddresses: 'IPAM þekkir engin vistföng þessa hnúts innan valda undirnetsins',
        started: 'Klasi búinn til — bootstrap heldur áfram sem makróverk; fasinn uppfærist sjálfur',
        error: 'Klasanum var hafnað'
      },
      detail: {
        actions: 'Tiltækar aðgerðir',
        tabOverview: 'Yfirlit',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pool',
        tabObjects: 'Hlutir',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Ítarlegt',
        phase: 'Fasi',
        checksTitle: 'Virk heilsucheck',
        noChecks: 'Ekkert virkt heilsucheck',
        checkMuted: 'þaggað',
        summaryPools: 'Pool',
        summaryFilesystems: 'Skráakerfi',
        nodesCard: 'Hnútar',
        monHint: 'MGR keyrir samhýstur hverjum MON. Þrír MON eru ráðlagða quorum-ið; tilraunaklasi byrjar með einum. OSD og MDS búa í sínum flipum.',
        monHintSplit: 'MON og MGR eru aðskildir á þessum klasa (Ítarlegt): hvert hlutverk er eigin aðild fyrir hvern hnút. Þrír MON eru ráðlagða quorum-ið; að minnsta kosti einn MGR verður að vera til.',
        noMons: 'Enginn monitor yfirlýstur',
        addNode: 'Bæta við hnút',
        removeNode: 'Fjarlægja hnút',
        removeNodeFrom: 'Fjarlægja hnútinn {node} (MON hans og samhýsta MGR-inn)',
        roleMon: 'MON-hlutverk',
        roleMgr: 'MGR-hlutverk',
        roleNa: 'N/A',
        roleNotObserved: 'ekki enn athugað',
        monInQuorum: 'í quorum',
        monOutQuorum: 'utan quorum',
        mgrActive: 'virkur',
        mgrStandby: 'standby',
        addRoleMon: 'Bæta við MON-hlutverki',
        removeRoleMon: 'Fjarlægja MON-hlutverk',
        addRoleMgr: 'Bæta við MGR-hlutverki',
        removeRoleMgr: 'Fjarlægja MGR-hlutverk',
        restartMon: 'Endurræsa MON-þjónustu',
        restartMgr: 'Endurræsa MGR-þjónustu',
        addMon: 'Bæta við MON',
        removeMon: 'Fjarlægja MON',
        removeMonFrom: 'Fjarlægja MON-hlutverkið af {node}',
        addMgr: 'Bæta við MGR',
        removeMgr: 'Fjarlægja MGR',
        removeMgrFrom: 'Fjarlægja MGR-hlutverkið af {node}',
        addMds: 'Bæta við MDS',
        removeMds: 'Fjarlægja MDS',
        removeMdsFrom: 'Fjarlægja MDS-hlutverkið af {node}',
        mdsSection: 'Metadata server (MDS)',
        noMds: 'Enginn MDS yfirlýstur — skráakerfi krefst eins fyrst',
        mdsHint: 'MDS-aðildin er sjálfstæð frá fyrsta degi: klasi án CephFS lýsir engum yfir, einn virkur auk eins standby þjóna skráakerfi vel. Ceph kýs virka og standby úr yfirlýstu púkunum.',
        mdsActiveFor: 'virkur — {fs}',
        mdsNotObserved: 'ekki enn athugaður',
        lastMdsGuard: 'Síðasta MDS-inn er ekki hægt að fjarlægja meðan skráakerfi er til — fjarlægðu skráakerfin fyrst',
        lastMonGuard: 'Síðasta MON-inn er ekki hægt að fjarlægja — að eyðileggja klasann er eina útgönguleiðin',
        lastMgrGuard: 'Síðasta MGR-inn er ekki hægt að fjarlægja — stýrður klasi keyrir aldrei án manager',
        registerDevice: 'Bæta við OSD',
        unregisterDevice: 'Afskrá',
        activeDeviceGuard: 'Virkur OSD — hann fer út gegnum OSD-lífsferilinn, ekki úr skránni',
        colNode: 'Hnútur',
        devicePhase: { registered: 'Skráð', active: 'Virkt' },
        health: 'Heilsa',
        state: 'Staða',
        fsid: 'fsid',
        fsidPending: 'vantar — reyndu bootstrap aftur',
        version: 'Ceph-útgáfa',
        publicNetwork: 'Public-net',
        clusterNetwork: 'Cluster-net',
        clusterNetworkCollapsed: '= public',
        noActions: 'Engin aðgerð tiltæk í þessum fasa',
        destroyedNote: 'Klasi eyðilagður — röðin er fjarlægð sjálfkrafa innan skamms'
      },
      overview: {
        services: 'Þjónustur',
        ok: 'heilbrigðar',
        warning: 'warning',
        down: 'niðri',
        pgTitle: 'Stöður PG-anna',
        pgTotal: '{n} PG alls',
        capacityTitle: 'Pláss',
        ioTitle: 'Núverandi I/O',
        ioReadBw: 'Lesbandbreidd',
        ioWriteBw: 'Skrifbandbreidd',
        ioReadIops: 'Les-IOPS',
        ioWriteIops: 'Skrif-IOPS',
        notObserved: 'ekki enn athugað'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Staða',
        colSize: 'Stærð',
        colPgs: 'PG',
        empty: 'Enginn OSD — bættu einum við af yfirlýstum gagnadiski',
        markIn: 'Merkja IN',
        markOut: 'Merkja OUT',
        scrub: 'Keyra scrub',
        deepScrub: 'Keyra djúpt scrub',
        restart: 'Endurræsa þjónustu',
        details: 'Nánar',
        actionGuard: 'Aðeins á virkum OSD á deployuðum klasa',
        inTitle: 'Merkja OSD IN',
        inBody: 'osd.{id} snýr aftur í gagnadreifinguna (ceph osd in): Ceph endurjafnar gögn yfir á hann.',
        outTitle: 'Merkja OSD OUT',
        outBody: 'osd.{id} fer út úr gagnadreifingunni (ceph osd out): gögn hans endurjafnast annars staðar og seiglan er SKERT meðan backfill keyrir. Afturkræft hvenær sem er með Merkja IN.',
        scrubTitle: 'Áætla scrub',
        scrubBody: 'Scrub á osd.{id} er sett í áætlun: mon-inn raðar því í biðröð og PG-stöður næstu sweep-a segja frá niðurstöðunni.',
        deepScrubTitle: 'Áætla djúpt scrub',
        deepScrubBody: 'Djúpt scrub á osd.{id} er sett í áætlun: afbrigðið sem sannreynir bætin — þyngra á I/O, sama gangverk.',
        restartTitle: 'Endurræsa OSD-þjónustu',
        restartBody: 'osd.{id} er stöðvaður og endurræstur gegnum umsjón worker-sins á hnút hans.',
        started: 'Aðgerð hafin — athugunin uppfærist sjálf',
        error: 'OSD-aðgerðinni var hafnað'
      },
      osdDetail: {
        title: 'Nánar um OSD',
        tabGeneral: 'Almennt',
        tabNetwork: 'Net',
        tabDevices: 'Tæki',
        version: 'Útgáfa',
        hostname: 'Hýsilnafn',
        dataPath: 'Gagnaslóð OSD',
        objectStore: 'Object store OSD',
        encrypted: 'Dulkóðaður',
        yes: 'Já',
        no: 'Nei',
        memory: 'Minnisnotkun (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front-vistfang (biðlarar & monitorar)',
        hbFront: 'Front-vistfang heartbeat',
        back: 'Back-vistfang (OSD)',
        hbBack: 'Back-vistfang heartbeat',
        colDevice: 'Tæki',
        colType: 'Tegund',
        colPhysical: 'Efnislegt tæki',
        colSize: 'Stærð',
        volumeTitle: 'Nánar um volume',
        creationTime: 'Stofndagur',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Ekkert tæki athugað fyrir þennan OSD'
      },
      restart: {
        title: 'Endurræsa þjónustu',
        monBody: 'MON-púkinn á {node} er stöðvaður og endurræstur gegnum umsjón worker-sins.',
        mgrBody: 'MGR-púkinn á {node} er stöðvaður og endurræstur gegnum umsjón worker-sins.',
        started: 'Endurræsing hafin — athugunin uppfærist sjálf',
        error: 'Endurræsingunni var hafnað'
      },
      encryptionMode: {
        alwaysOn: 'Alltaf virk (dmcrypt)',
        alwaysOff: 'Alltaf óvirk',
        perOsd: 'Val fyrir hvern OSD',
        section: 'OSD-dulkóðun at rest',
        title: 'Skipta um OSD-dulkóðunarham',
        hint: 'Hvernig NÝIR OSD-ar eru undirbúnir. Fyrirliggjandi OSD-ar halda sinni stöðu fyrir hvern disk: til að breyta henni er OSD-inn fjarlægður og endurgerður.',
        body: 'Hamurinn verður „{mode}“ og gildir AÐEINS fyrir NÝJA OSD-a: hver fyrirliggjandi OSD heldur núverandi dulkóðunarstöðu sinni.',
        apply: 'Skipta um ham',
        error: 'Hamskiptunum var hafnað'
      },
      pin: {
        address: 'Public-vistfang (valfrjálst pin)',
        clusterAddress: 'Cluster-vistfang (valfrjálst pin)',
        autoPlaceholder: 'sjálfvirkt innan undirnetsins {cidr}',
        hint: 'Vistföng fyrir hvern púka: autt = Ceph festir sig sjálft innan yfirlýsta netsins; útfyllt = þetta tilvik er pinnað á vistfangið í conf-hluta sínum.'
      },
      addMon: {
        title: 'Bæta við hnút',
        node: 'Hnútur',
        address: 'Public-vistfang',
        addressHint: 'Vistföng hnútsins sem IPAM þekkir innan public-undirnetsins — sjálfvirkt þegar fyrirliggjandi yfirlýsing nær yfir hnútinn.',
        clusterAddress: 'Cluster-vistfang',
        clusterAddressHint: 'Skylda: cluster-undirnetið er aðskilið og hnúturinn er ekki enn yfirlýstur í því.',
        noAddresses: 'IPAM þekkir engin vistföng þessa hnúts innan undirnetsins',
        error: 'Viðbót mon-sins var hafnað'
      },
      removeMon: {
        title: 'Fjarlægja MON',
        body: 'MON-inn og samhýsti MGR-inn hans yfirgefa hnútinn {node}. Á deployuðum klasa eru púkarnir stöðvaðir og fjarlægðir úr quorum-inu.',
        error: 'Fjarlægingu MON-sins var hafnað'
      },
      addMgr: {
        title: 'Bæta við MGR',
        node: 'Hnútur',
        hint: 'Ítarlegt (MON/MGR aðskildir): sjálfstæður manager fæðist á valda meðlimshnútnum með verki bundnu hnútnum. Active/standby-kosning Ceph velur sjálf virka MGR-inn.',
        error: 'Viðbót MGR-sins var hafnað'
      },
      removeMgr: {
        title: 'Fjarlægja MGR',
        body: 'Sjálfstæði MGR-inn yfirgefur hnútinn {node}. Á deployuðum klasa er púkinn stöðvaður og staða hans fjarlægð; MON hnútsins (sé hann til) er ekki snertur.',
        error: 'Fjarlægingu MGR-sins var hafnað'
      },
      addMds: {
        title: 'Bæta við MDS',
        node: 'Hnútur',
        hint: 'Metadata server CephFS: hann fæðist á valda meðlimshnútnum með verki bundnu hnútnum, undir umsjón worker-sins eins og MON og MGR. Ceph kýs sjálft virka og standby — einn virkur auk eins standby þjóna skráakerfi vel.',
        error: 'Viðbót MDS-sins var hafnað'
      },
      removeMds: {
        title: 'Fjarlægja MDS',
        body: 'MDS-inn yfirgefur hnútinn {node}. Á deployuðum klasa er púkinn stöðvaður og staða hans fjarlægð; API hafnar síðasta MDS-inum meðan skráakerfi þarfnast hans.',
        error: 'Fjarlægingu MDS-sins var hafnað'
      },
      split: {
        title: 'MON/MGR aðskildir',
        label: 'Leyfa MON og MGR á aðskildum hnútum',
        hint: 'Óvirkt (sjálfgefið) = staðfesti staðallinn: MGR keyrir samhýstur hverjum MON, ein aðild. Virkt = aðild MGR-anna verður sjálfstæð, stýrð með aðgerðunum Bæta við/Fjarlægja MGR í MON & MGR flipanum.',
        enable: 'Virkja',
        disable: 'Afvirkja',
        enableBody: 'Aðild MGR-anna verður óháð MON-unum, frumstillt af núverandi samhýsingu. Aðgerðirnar Bæta við/Fjarlægja MGR virkjast í MON & MGR flipanum. Þetta slakar á sjálfgefnum vettvangsstaðli — haltu því aðeins ef þú veist hvers vegna þú þarft það.',
        disableBody: 'Aftur í staðlaða samhýsingu: einn MGR með hverjum MON, ein aðild. Aðeins löglegt ef aðild MGR-anna fellur þegar saman við MON-ana — jafnaðu hana fyrst með Bæta við/Fjarlægja MGR, annars hafnar API-ið.',
        error: 'Breytingunni var hafnað'
      },
      rawEditor: {
        title: 'Hrár CRUSH-ritill',
        label: 'Sýna hráa crushmap-ritilinn í CRUSH-flipanum',
        hint: 'Óvirkt (sjálfgefið) = leiðsagða regluyfirborðið er staðlaða tólið. Virkt = CRUSH-flipinn sýnir líka afþýdda crushmap-ið sem breytanlegan texta. Vistun krefst alltaf sudo, nafns klasans til staðfestingar, og fer gegnum compile + test crushtool ÁÐUR en hún nær klasanum.'
      },
      osdFlags: {
        section: 'Altæk OSD-flögg',
        title: 'Yfirtaka OSD-flagga',
        notObserved: 'ekki enn athuguð',
        standardFlowsHint: 'Stöðluðu flæði vettvangsins stjórna þessum flöggum sjálf í venjulegum tilfellum (viðhald hnúts setur markvisst noout, diskaskipti fara gegnum OSD-lífsferilinn). Þessi hluti er handvirka yfirtakan fyrir rekstraraðila sem veit hvað hann er að gera.',
        notDeployedGuard: 'OSD-flögg eru aðeins til á deployuðum klasa',
        set: 'Setja flagg',
        unset: 'Fjarlægja flagg',
        setBody: 'Altæka flaggið {flag} verður SETT á osdmap-ið. Það situr þar til það er fjarlægt skýrt — gleymt flagg skerðir sjálfsviðgerð klasans.',
        unsetBody: 'Altæka flaggið {flag} verður FJARLÆGT af osdmap-inu.',
        error: 'Flaggbreytingunni var hafnað',
        flag: {
          noout: 'Enginn OSD er merktur out úr gagnadreifingunni — engin endurjöfnun við missi púka',
          norebalance: 'Endurjöfnun gagnanna er í bið',
          nobackfill: 'Backfill er í bið',
          norecover: 'Recovery er í bið',
          pause: 'ALLT I/O biðlaranna er í bið (lestrar og skriftir)',
          noin: 'OSD-ar sem ræsast eru ekki merktir in sjálfkrafa',
          nodown: 'Ónáanlegir OSD-ar eru ekki merktir down — felur raunverulegar bilanir'
        }
      },
      pools: {
        section: 'Pool',
        create: 'Búa til pool',
        createGuard: 'Pool eru aðeins til á deployuðum klasa',
        notObserved: 'Engin athugun á pool-unum — sweep mon-sins skilar hingað',
        empty: 'Ekkert pool á klasanum',
        colName: 'Nafn',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Application',
        colRule: 'CRUSH-regla',
        colUsage: 'Notkun',
        observedAtLabel: 'Athugað þann',
        objects: '{n} hlutir',
        inUseBy: 'í notkun hjá {name}',
        internalGuard: 'Innra pool Ceph — vettvangurinn eyðir því aldrei',
        delete: 'Eyða pool-i',
        deleteGuard: 'Neytt af geymslunni {name} — eyddu geymslunni fyrst',
        hint: 'Aðeins spegluð pool (erasure coding utan v1-marka). Speglunin býr í Ceph: þessi tafla er sannleikurinn athugaður af sweep-i mon-sins.',
        createTitle: 'Búa til pool',
        createHint: 'Pool-ið fæðist á klasanum með umbeðinni speglun og rbd-application virkri — vinnuna vinnur verk á MON-hnút. Kveiktu á „Bjóða fram sem geymslu“ til að neyta þess strax í sama handtaki.',
        name: 'Nafn pool-sins',
        nameHint: 'DNS-öruggt (lágstafir, tölustafir, bandstrik).',
        size: 'Speglar (size)',
        sizeHint: 'Afrit hvers hlutar. Sjálfgefið 3.',
        minSize: 'Lágmarksspeglar (min_size)',
        minSizeHint: 'Lágmarksafrit til að þjóna I/O — fylgir size − 1 þar til þú breytir því.',
        createError: 'Stofnun pool-sins var hafnað',
        deleteTitle: 'Eyða pool-i',
        deleteBody: 'Pool-ið {pool} og HVER hlutur innan þess eru eyðilögð óafturkræft. Sláðu inn nafn pool-sins til að staðfesta.',
        confirmLabel: 'Nafn pool-sins',
        confirmHint: 'Sláðu inn nafn pool-sins til að staðfesta',
        deleteError: 'Eyðingu pool-sins var hafnað',
        detailTitle: 'Nánar um pool',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Virkur',
        autoscalerOff: 'Óvirkur',
        autoscalerWarn: 'Tilkynning',
        pgNumLabel: 'Fjöldi PG',
        pgNumCaption: 'Athugað: autoscaler-inn getur breytt því upp á eigin spýtur — þetta svæði skrifar ósk.',
        storage: 'Tengd TVirt-geymsla',
        addAsStorage: 'Bæta við sem TVirt-geymslu',
        ruleSudoHint: 'Skipti á CRUSH-reglunni krefjast lykilorðs rekstraraðilans.',
        updateError: 'Breytingu pool-sins var hafnað',
        updated: 'Breyting pool-sins hafin — athugunin uppfærist sjálf'
      },
      crush: {
        section: 'CRUSH-reglur',
        notObserved: 'Engin CRUSH-athugun enn — sweep mon-sins skilar hingað',
        empty: 'Engin regla athuguð á klasanum',
        hint: 'Regla ákveður HVERT afrit hvers hlutar fara — bilunarsvið hennar er einingin sem má bila án þess að gögn tapist. Pool-in benda á reglu; innbyggða replicated_rule (eitt afrit á þjón) er sjálfgefna fæðingargildið.',
        create: 'Búa til reglu',
        createGuard: 'CRUSH-reglur eru aðeins til á deployuðum klasa',
        createTitle: 'Búa til CRUSH-reglu',
        createHint: 'Ein regla = eitt val á bilunarsviði. Reglan fæðist spegluð á sjálfgefnu rótinni — vinnuna vinnur verk á MON-hnút; tengdu pool-in úr Pool-flipanum á eftir.',
        createError: 'Stofnun reglunnar var hafnað',
        name: 'Nafn reglunnar',
        nameHint: 'DNS-öruggt (lágstafir, tölustafir, bandstrik).',
        domain: 'Bilunarsvið',
        domainChoice: {
          osd: 'Hvert afrit á ólíkum OSD',
          host: 'Hvert afrit á ólíkum þjóni',
          rack: 'Hvert afrit í ólíkum rekka'
        },
        domainCustom: 'Sérsniðið (skref skrifuð í höndunum)',
        domainOther: 'Hvert afrit í ólíku {type}',
        rackGuardHint: 'Ekkert rack-bucket er til í athugaða stigveldinu: regluna má samt búa til, en ekkert pool getur bent á hana fyrr en rekki er yfirlýstur í staðsetningu meðlimsþjónanna (stillingar hnútsins) — endurjöfnunarverkið byggir bucket-ið og tengingin opnast af sjálfu sér.',
        treeTitle: 'Athugað stigveldi',
        treeNotObserved: 'Engin athugun á stigveldinu — sweep mon-sins skilar hingað',
        treeOsds: '{n} OSD',
        treeHint: 'CRUSH-kortið eins og klasinn sér það: rót → yfirlýst stig → þjónar (host) → OSD. Grannfræðin fylgir yfirlýstri staðsetningu hvers þjóns (stillingar hnútsins) — staðsetningarbreyting endurjafnar hana gegnum verk.',
        unplacedWarning: 'Meðlimir án yfirlýstrar staðsetningar: {nodes} — host-in þeirra sitja beint undir rótinni, utan yfirlýstu grannfræðinnar. Lýstu staðsetningunni yfir í stillingum hnútsins (aðvörun, aldrei stopp).',
        colName: 'Nafn',
        colDomain: 'Bilunarsvið',
        colPools: 'Pool',
        builtinChip: 'builtin',
        builtinGuard: 'Sjálfgefna regla klasans — vettvangurinn eyðir henni aldrei',
        detailAction: 'Nánar um reglu',
        detailType: 'Tegund',
        backToRules: 'Reglur',
        ruleNotObserved: 'Athugaði reglulistinn nefnir ekki þessa reglu',
        noPools: 'Ekkert pool situr á þessari reglu',
        delete: 'Eyða reglu',
        deleteTitle: 'Eyða CRUSH-reglu',
        deleteBody: 'Reglan {rule} er fjarlægð úr crushmap-i klasans. Ekkert pool má sitja á henni. Sláðu inn nafn reglunnar til að staðfesta.',
        deleteGuard: 'Pool-ið {name} situr á henni — beindu pool-inu annað fyrst',
        confirmLabel: 'Nafn reglunnar',
        confirmHint: 'Sláðu inn nafn reglunnar til að staðfesta',
        deleteError: 'Eyðingu reglunnar var hafnað',
        changeRule: 'Skipta um CRUSH-reglu',
        changeRuleTitle: 'Skipta um CRUSH-reglu',
        changeRuleHint: 'Pool-ið byrjar að staðsetja hluti sína eftir völdu reglunni — Ceph flytur fyrirliggjandi gögn til samræmis (á fullu pool-i fylgir endurjöfnun).',
        changeRuleError: 'Regluskiptunum var hafnað',
        rule: 'CRUSH-regla',
        rawTitle: 'Hrátt crushmap (afþýtt)',
        rawWarning: 'HÆTTA: þessi texti er ÖLL staðsetningarstefna klasans. Rangt kort getur brotið staðsetningu allra pool-anna í einu. Vistun þýðir og prófar kortið með crushtool ÁÐUR en það er sett inn — en gilt kort getur samt verið slæm hugmynd.',
        rawReload: 'Endurhlaða',
        rawLoading: 'Fyrirspurn á flugi — read-only verk er að afþýða crushmap-ið…',
        rawSave: 'Vista crushmap',
        rawSaveTitle: 'Setja inn crushmap',
        rawSaveBody: 'Breytti textinn kemur í stað crushmap-s ALLS klasans eftir compile + test crushtool. Sláðu inn nafn klasans til að staðfesta.',
        rawConfirmLabel: 'Nafn klasans',
        rawConfirmHint: 'Sláðu inn {name} til að staðfesta',
        rawError: 'Aðgerðin á crushmap-inu mistókst',
        rawHint: 'Textinn er á forminu crushtool -d. Þýðingar- og prófunarvillur skila sér orðréttar frá crushtool — kortið nær ekki klasanum ef annað hliðanna tveggja fellur.'
      },
      objects: {
        poolsSection: 'Hlutaskoðari',
        poolsHint: 'Veldu pool til að telja upp RBD-myndir þess. Hver djúpur lestur keyrir sem read-only verk á MON-hnút — hann blokkar hvorki (né er blokkaður af) raunverulegu aðgerðunum.',
        deployedGuard: 'Hlutafyrirspurnir svara aðeins á deployuðum klasa',
        browse: 'Fletta hlutunum',
        detailAction: 'Nánar um mynd',
        backToPools: 'Pool',
        backToImages: 'Myndir',
        refresh: 'Uppfæra',
        loading: 'Fyrirspurn á flugi — read-only verk er að spyrja klasann…',
        error: 'Fyrirspurnin mistókst',
        retry: 'Reyna aftur',
        notRbd: 'Pool með application „{app}“ — inniheldur engar RBD-myndir, ekkert að skoða hér',
        noImages: 'Engin RBD-mynd í þessu pool-i',
        colImage: 'Mynd',
        colSize: 'Stærð',
        colObjects: 'Hlutir',
        colSnapshots: 'Skyndimyndir',
        imagesHint: 'Diskarnir á rbd-neytandi geymslu eru myndir með nafni disk-id-sins síns. Hlutatalningin er provisioned (stærð / hlutastærð) — raunnotkunin býr í nánari upplýsingum myndarinnar.',
        infoTitle: 'Mynd',
        infoSize: 'Sýndarstærð',
        infoObjects: 'Hlutir (provisioned)',
        infoObjectSize: 'Hlutastærð',
        infoPrefix: 'Forskeyti hluta',
        infoFormat: 'Snið',
        infoFeatures: 'Feature',
        usageTitle: 'Raunnotkun (rbd du)',
        usageOf: 'af {provisioned} GiB provisioned',
        usageHint: 'Thin í eðli sínu: aðeins skrifaðir hlutir taka bæti.',
        watchersTitle: 'Watcher',
        noWatchers: 'Enginn watcher — enginn hefur þessa mynd opna núna',
        snapshotsTitle: 'RBD-skyndimyndir',
        noSnapshots: 'Engin RBD-skyndimynd á þessari mynd',
        colSnapshot: 'Skyndimynd',
        colProtected: 'Varin',
        colTimestamp: 'Búin til',
        protected: 'varin',
        mappingTitle: 'Efnisleg vörpun (OSD-mengi)',
        mappingSampled: 'Úrtak {sampled} hluta af {total} — heiðarleg samantekt: fyrir stórar myndir rennur mengið saman við ALLA OSD-a pool-sins (CRUSH dreifir hlutunum yfir allt pool-ið).',
        mappingComplete: 'Allir hlutir varpaðir ({total} af {total}).',
        objectQueryTitle: 'Varpa stökum hlut',
        objectName: 'Nafn hlutar',
        objectHint: 'RADOS-hlutanöfn eru <forskeyti>.<vísir 16-hex> — ceph osd map svarar með PG og OSD-þrenndum.',
        mapObject: 'Varpa',
        primary: 'aðal: osd.{osd}'
      },
      registerDevice: {
        title: 'Skrá OSD-tæki',
        hint: 'Á lifandi klasa UNDIRBÝR skráningin líka tækið: það verður BlueStore-OSD með sjálfvirku verki bundnu hnútnum (aldrei tómt, staðfest 2026-07-24). Tæki tilheyrir í mesta lagi einum Ceph-klasa í öllum flotanum.',
        disk: 'Gagnadiskur',
        diskHint: 'Yfirlýstu gagnadiskar hnútsins — nafn og raðnúmer',
        noDeclared: 'Enginn gagnadiskur yfirlýstur á þessum hnút — merktu þá fyrst í staðbundnum stillingum hnútsins',
        serialHint: 'Raðnúmer tækisins — auðkennispinninn',
        encrypted: 'Dulkóða þennan OSD (dmcrypt)',
        encryptedHint: 'Valið fyrir hvern OSD (hamur klasans er „val fyrir hvern OSD“): það frýs á þessum diski við skráninguna — síðari hamskipti endurskrifa það aldrei; það gerir línuaðgerðin dulkóða/afdulkóða.',
        error: 'Skráningunni var hafnað'
      },
      unregisterDevice: {
        title: 'Afskrá tæki',
        body: 'Aðeins í skránni: {name} hættir að vera OSD-kandídat þessa klasa. Bæti þess eru ekki snert.',
        error: 'Afskráningunni var hafnað'
      },
      deploy: {
        action: 'Reyna deploy aftur',
        title: 'Reyna bootstrap aftur',
        body: 'Fæðingar-bootstrapið fer aftur af stað frá núverandi stillingum: mon-arnir ræsast, hvert skráð tæki er undirbúið og virkjað sem BlueStore-OSD. Aðgerðin keyrir sem makróverk — fasinn uppfærist sjálfur.',
        started: 'Bootstrap hafið — heldur áfram sem makróverk; fasinn uppfærist sjálfur',
        error: 'Bootstrap-inu var hafnað'
      },
      propose: {
        action: 'Bjóða fram sem geymslu',
        title: 'Bjóða fram sem geymslu',
        hintPool: 'Fyrirliggjandi pool {name} verður TVirt-geymsla: cephx-auðkenni takmarkað við pool-ið fer í keystore og ceph-rbd-geymslan fæðist tilbúin. Framboðið neytir pool-sins — býr það aldrei til.',
        hintFs: 'Fyrirliggjandi skráakerfið {name} verður TVirt-geymsla: cephx-auðkenni takmarkað við skráakerfið fer í keystore og cephfs-geymslan fæðist tilbúin og tengd. Framboðið neytir skráakerfisins — býr það aldrei til.',
        name: 'Nafn geymslunnar',
        nameHint: 'DNS-1123, einkvæmt innan scope — cephx-auðkennið tekur nafn sitt af henni.',
        path: 'Slóð innan skráakerfisins',
        pathHint: 'Alger slóð innan skráakerfisins sem geymslan tengir — / í vafa.',
        alsoPropose: 'Bjóða strax fram sem geymslu',
        alsoProposePoolHint: 'Eftir stofnunina býður sama handtakið nýfædda pool-ið fram sem ceph-rbd-geymslu — tvö skýr köll, einn gluggi.',
        alsoProposeFsHint: 'Eftir stofnunina býður sama handtakið nýfædda skráakerfið fram sem cephfs-geymslu — tvö skýr köll, einn gluggi.',
        guard: 'Bjóða fram sem geymslu — aðeins á heilbrigðum klasa',
        started: 'Framboð samþykkt — geymslan er að raungerast; þú finnur hana undir Geymslur',
        submit: 'Búa til geymslu',
        error: 'Framboðinu var hafnað'
      },
      fs: {
        section: 'Skráakerfi',
        create: 'Búa til skráakerfi',
        createGuard: 'Skráakerfi eru aðeins til á deployuðum klasa',
        mdsFirstGuard: 'Bættu fyrst við MDS — skráakerfi án metadata server fæðist ónothæft',
        notObserved: 'Engin athugun á skráakerfunum — sweep MON-sins skilar hingað',
        empty: 'Ekkert skráakerfi á klasanum',
        colName: 'Nafn',
        colPools: 'Pool',
        colMds: 'MDS',
        noActiveMds: 'enginn virkur MDS',
        delete: 'Fjarlægja skráakerfi',
        deleteGuard: 'Neytt af geymslunni {name} — eyddu geymslunni fyrst',
        hint: 'Skráakerfi á gagna- og metadata-pool sín (cephfs.<nafn>.data / .meta): þau fæðast með því og deyja með því — removeFs, aldrei handvirk pool-eyðing. Þessi tafla er sannleikurinn athugaður af sweep-i MON-sins.',
        createTitle: 'Búa til skráakerfi',
        createHint: 'Skráakerfið fæðist á klasanum með pool-unum sínum tveimur (application cephfs) og er þjónað af yfirlýstu MDS-unum — vinnuna vinnur verk á MON-hnút. Kveiktu á „Bjóða fram sem geymslu“ til að neyta þess strax í sama handtaki.',
        name: 'Nafn skráakerfisins',
        nameHint: 'DNS-öruggt (lágstafir, tölustafir, bandstrik).',
        sizeHint: 'Speglar BEGGJA nýfæddu pool-anna. Sjálfgefið 3.',
        createError: 'Stofnun skráakerfisins var hafnað',
        deleteTitle: 'Fjarlægja skráakerfi',
        deleteBody: 'Skráakerfið {fs} og HVER skrá innan þess eru eyðilögð óafturkræft — gagna- og metadata-pool þess deyja með því. Sláðu inn nafn skráakerfisins til að staðfesta.',
        confirmLabel: 'Nafn skráakerfisins',
        confirmHint: 'Sláðu inn nafn skráakerfisins til að staðfesta',
        deleteError: 'Fjarlægingu skráakerfisins var hafnað'
      },
      destroy: {
        action: 'Eyðileggja',
        retryAction: 'Reyna eyðinguna aftur',
        retryGuard: 'Eyðileggingin er í gangi — retry gildir fyrir misheppnaða eyðileggingu (lease-ið hafnar annars)',
        title: 'Eyðileggja klasann',
        body: 'Deployaða fabric-ið er rifið niður: hver púki þessa klasa stöðvast, kerfisstaða hans og lyklarnir í keystore eru gefnir laus. Takist eyðileggingin er klasinn fjarlægður sjálfkrafa.',
        confirmLabel: 'Nafn klasans',
        confirmHint: 'Sláðu inn nafn klasans til að staðfesta',
        wipe: 'Þurrka skráðu tækin',
        wipeHint: 'Hakað: undirskriftir hvers skráðs tækis eru þurrkaðar út — gögnin ofan á eru eyðilögð. Óhakað: bætin haldast ósnert og tækin verða aftur skráð.',
        guard: 'Eyðileggja — ekkert deployað',
        started: 'Eyðilegging hafin — heldur áfram sem makróverk; fasinn uppfærist sjálfur',
        error: 'Eyðileggingunni var hafnað'
      },
      delete: {
        guard: 'Eyða — aðeins stillingum sem ekki eru deployaðar (eyðileggðu fyrst)',
        title: 'Eyða {name}?',
        body: 'Stillingarnar og tækjaskrá þeirra eru fjarlægðar. Aðeins löglegt meðan ekkert er deployað.',
        error: 'Eyðingunni var hafnað'
      }
    }
  }
}
